import { MenuID } from 'src/types';
export var pagePermissions = [{
  name: 'reservation_page',
  type: 'page',
  subject: MenuID.reservation,
  description: '進入「預約列表（/）」頁、顯示「預約列表」入口'
}, {
  name: 'onboard_page',
  type: 'page',
  subject: MenuID.onboard,
  description: '進入「看診清單（/onboard）」頁、顯示「看診清單」入口'
}, {
  name: 'client_list_page',
  type: 'page',
  subject: MenuID.client_list,
  description: '進入「客戶列表（/client_list）」頁、顯示「客戶列表」入口'
}, {
  name: 'client_page',
  type: 'page',
  subject: MenuID.client,
  description: '進入「客戶資料（/client）」頁'
}, {
  name: 'order_page',
  type: 'page',
  subject: MenuID.order,
  description: '進入「客戶訂單（/client/order）」頁'
}, {
  name: 'deliverynote_page',
  type: 'page',
  subject: MenuID.deliverynote,
  description: '進入「藥局出庫（/deliverynote）」頁、顯示「藥局出庫」入口'
}, {
  name: 'dispensation_order_page',
  type: 'page',
  subject: MenuID.dispensationOrder,
  description: '進入「領藥單（/deliverynote/order）」頁'
}, {
  name: 'stock_page',
  type: 'page',
  subject: MenuID.inventory,
  description: '顯示「庫存管理」入口'
}, {
  name: 'stock_news_page',
  type: 'page',
  subject: MenuID.stock_news,
  description: '進入「庫存公告（/stock_news）」頁、顯示「庫存公告」入口'
}, {
  name: 'restock_list_page',
  type: 'page',
  subject: MenuID.restock_list,
  description: '進入「入庫管理（/restock_list）」頁、顯示「入庫管理」入口'
}, {
  name: 'restock_add_page',
  type: 'page',
  subject: MenuID.restock_add,
  description: '進入「新增入庫（/restock_add）」頁'
}, {
  name: 'daily_inventory_page',
  type: 'page',
  subject: MenuID.daily_inventory,
  description: '進入「今日盤點（/daily_inventory）」頁、顯示「今日盤點」入口'
}, {
  name: 'info_mgmt_page',
  type: 'page',
  subject: MenuID.info_mgmt,
  description: '進入「資料維護（/info_mgmt）」頁、顯示「資料維護」入口'
}, {
  name: 'measurement_mgmt_page',
  type: 'page',
  subject: MenuID.measurement_mgmt,
  description: '進入「量測資料轉移（/measurement_mgmt）」頁、顯示「量測資料轉移」入口'
}, {
  name: 'client_mgmt_page',
  type: 'page',
  subject: MenuID.client_mgmt,
  description: '進入「客戶管理（/client_mgmt）」頁、顯示「客戶管理」入口'
}, {
  name: 'chatroom_page',
  type: 'page',
  subject: MenuID.chatroom,
  description: '進入「大聊天室（/chatroom）」頁、顯示「大聊天室」入口'
}, {
  name: 'medical_analysis_page',
  type: 'page',
  subject: MenuID.cg_report,
  description: '顯示「醫療分析」入口'
}, {
  name: 'analysis_guide_page',
  type: 'page',
  subject: MenuID.analysisGuide,
  description: '進入「諮詢手冊互動工具（/analysis_guide）」頁'
}, {
  name: 'analysis_guide_diet_page',
  type: 'page',
  subject: MenuID.analysisGuideDiet,
  description: '進入「諮詢手冊互動工具－飲食（/analysis_guide/diet）」頁'
}, {
  name: 'analysis_guide_target_page',
  type: 'page',
  subject: MenuID.analysisGuideTarget,
  description: '進入「諮詢手冊互動工具－目標（/analysis_guide/target）」頁'
}, {
  name: 'instant_food_tool_page',
  type: 'page',
  subject: MenuID.instantFoodTool,
  description: '進入「飲食接案工具（/instant_food_tool）」頁'
}];
export var dataPermissions = [{
  name: 'read_branch_visit_record_number',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'record_number',
  description: '顯示預約列表頁「病歷資料」欄位'
}, {
  name: 'read_branch_visit_provider_name',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'provider_name',
  description: '顯示預約列表頁「負責人」欄位'
}, {
  name: 'read_branch_visit_formattedPhone',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'formattedPhone',
  description: '顯示SB號碼'
}, {
  name: 'read_branch_visit_phone',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'phone',
  description: '顯示SB號碼(原始資料，有國碼)'
}, {
  name: 'update_branch_visit_provider_name',
  type: 'data',
  subject: 'branch_visit',
  action: 'update',
  property: 'provider_name',
  description: '編輯預約列表頁「負責人」欄位'
}, {
  name: 'read_branch_visit_state',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'state',
  description: '顯示預約列表頁「報到狀態」欄位'
}, {
  name: 'update_branch_visit_state',
  type: 'data',
  subject: 'branch_visit',
  action: 'update',
  property: 'state',
  description: '編輯預約列表頁「報到狀態」欄位'
}, {
  name: 'update_branch_visit_confirmed_at',
  type: 'data',
  subject: 'branch_visit',
  action: 'update',
  property: 'confirmed_at',
  description: '編輯預約列表頁「確認狀態」欄位（僅 HQ 顯示此欄位）'
}, {
  name: 'update_branch_visit_visit_purposes',
  type: 'data',
  subject: 'branch_visit',
  action: 'update',
  property: 'visit_purposes',
  description: '編輯預約列表頁「實際項目」欄位'
}, {
  name: 'read_branch_visit_therapy_type',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'therapy_type',
  description: '顯示預約列表頁「療程種類」欄位'
}, {
  name: 'read_branch_visit_therapy_stage',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'therapy_stage',
  description: '顯示預約列表頁「療程階段」欄位'
}, {
  name: 'read_branch_visit_pre_rd',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'pre_rd',
  description: '顯示預約列表頁「前諮營養師」欄位'
}, {
  name: 'read_branch_visit_line_bound_status',
  type: 'data',
  subject: 'branch_visit',
  action: 'read',
  property: 'lineBoundStatus',
  description: '顯示預約列表頁「LINE 狀態」欄位（僅 HQ 顯示欄位）'
}, {
  name: 'update_order_order_type',
  type: 'data',
  subject: 'order',
  action: 'update',
  property: 'order_type',
  description: '編輯訂單「類別」'
}, {
  name: 'update_order_practitioner',
  type: 'data',
  subject: 'order',
  action: 'update',
  property: 'practitioner',
  description: '編輯訂單「負責人」'
}, {
  name: 'update_order_salesperson',
  type: 'data',
  subject: 'order',
  action: 'update',
  property: 'reassign_items',
  description: '編輯訂單「銷售帳號」'
}, {
  name: 'update_order_payment_method',
  type: 'data',
  subject: 'order',
  action: 'update',
  property: 'payment_method',
  description: '編輯訂單「交易方式」'
}, {
  name: 'update_order_payment_note',
  type: 'data',
  subject: 'order',
  action: 'update',
  property: 'payment_note',
  description: '編輯訂單「交易備註」'
}, {
  name: 'update_order_payment_date_time',
  type: 'data',
  subject: 'order',
  action: 'update',
  property: 'payment_date_time',
  description: '編輯訂單「交易日期登記」（顯示訂單交易日期登記區塊）'
}, {
  name: 'create_soap_flc_first',
  type: 'data',
  subject: 'soap',
  action: 'create',
  property: 'flc_first',
  description: '新增「醫師門診」SOAP（顯示醫師門診按鈕）'
}, {
  name: 'create_soap_psychological_counseling',
  type: 'data',
  subject: 'soap',
  action: 'create',
  property: 'psychological_counseling',
  description: '新增「心理師諮詢」SOAP（顯示心理師諮詢按鈕）'
}, {
  name: 'create_soap_clinic_nutritional_counseling',
  type: 'data',
  subject: 'soap',
  action: 'create',
  property: 'clinic_nutritional_counseling',
  description: '新增「營養師門診」SOAP（顯示營養師門診按鈕）'
}, {
  name: 'update_soap_dr_comments',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'dr_comments',
  description: '編輯 SOAP「醫師紀錄」'
}, {
  name: 'update_soap_dietician_comments',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'dietician_comments',
  description: '編輯 SOAP「營養師紀錄」'
}, {
  name: 'update_soap_pre_rd_comments',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'pre_rd_comments',
  description: '編輯 SOAP「諮詢紀錄」'
}, {
  name: 'update_soap_post_rd_comments',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'post_rd_comments',
  description: '編輯 SOAP「跟診紀錄」'
}, {
  name: 'update_soap_nurse_comments',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'nurse_comments',
  description: '編輯 SOAP「護理師紀錄」'
}, {
  name: 'update_soap_pharmacist_comments',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'pharmacist_comments',
  description: '編輯 SOAP「藥師紀錄」'
}, {
  name: 'update_soap_plan_to_do',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'plan_to_do',
  description: '編輯 SOAP「PLAN TO DO」'
}, {
  name: 'update_soap_drug',
  type: 'data',
  subject: 'soap',
  action: 'update',
  property: 'drug',
  description: '編輯 SOAP「處方籤藥物」'
}];
export var actionPermissions = [{
  name: 'enter_client_profile',
  type: 'action',
  subject: 'client_profile',
  action: 'enter',
  description: '顯示預約列表頁「諮詢診療」欄位'
}, {
  name: 'enter_client_appointment_records',
  type: 'action',
  subject: 'client_appointment_records',
  action: 'enter',
  description: '顯示預約列表「預約歷程」欄位、病例搜尋 modal「諮詢診療」顯示預約歷程按鈕'
}, {
  name: 'enter_video_call',
  type: 'action',
  subject: 'video_call',
  action: 'enter',
  description: '顯示預約列表頁「視訊」欄位'
}, {
  name: 'enter_calendar_tab',
  type: 'action',
  subject: 'calendar_tab',
  action: 'enter',
  description: '顯示預約列表頁「日曆」Tab'
}, {
  name: 'enter_therapy_tab',
  type: 'action',
  subject: 'therapy_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「療程」Tab'
}, {
  name: 'enter_diagnosis_tab',
  type: 'action',
  subject: 'diagnosis_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「診療」Tab'
}, {
  name: 'enter_timeline_tab',
  type: 'action',
  subject: 'timeline_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「歷程瀏覽」Tab'
}, {
  name: 'enter_blood_sugar_tab',
  type: 'action',
  subject: 'blood_sugar_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「血糖」Tab'
}, {
  name: 'enter_client_questionnaire_tab',
  type: 'action',
  subject: 'client_questionnaire_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「客戶問卷」Tab'
}, {
  name: 'enter_body_mass_tab',
  type: 'action',
  subject: 'body_mass_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「身體數值」Tab'
}, {
  name: 'enter_phalanx_tab',
  type: 'action',
  subject: 'phalanx_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「基因檢測」Tab'
}, {
  name: 'enter_inspection_report_tab',
  type: 'action',
  subject: 'inspection_report_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「檢查報告」Tab'
}, {
  name: 'enter_report_3d_tab',
  type: 'action',
  subject: 'report_3d_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「3D」Tab'
}, {
  name: 'enter_abdominal_ultrasound_tab',
  type: 'action',
  subject: 'abdominal_ultrasound_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「超音波」Tab'
}, {
  name: 'enter_upload_file_tab',
  type: 'action',
  subject: 'upload_file_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「上傳檔案」Tab'
}, {
  name: 'enter_order_tab',
  type: 'action',
  subject: 'order_tab',
  action: 'enter',
  description: '顯示客戶資訊頁「訂單紀錄」Tab'
}];
export var permissions = [].concat(pagePermissions, dataPermissions, actionPermissions);